import React from 'react';

/**
 * Renderiza el bloque DepthMapView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DepthMapView({
  v
}) {
  return v.depIsMap ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": v.depCols,
      "gap": "0.185185vh",
      "alignItems": "end"
    }
  }, React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#5a667a"
    }
  }, v.text("m")), (v.depHead || []).map((h, index49) => React.createElement(React.Fragment, {
    key: index49
  }, React.createElement("span", {
    style: {
      "font": "0.925926vh 'IBM Plex Sans',sans-serif",
      "color": h.c,
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "clip",
      "textAlign": "center"
    }
  }, v.text(h.lab)))), React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "color": "#5a667a",
      "paddingLeft": "0.416667vw"
    }
  }, v.text(v.depTotLab))), v.text("\n      "), React.createElement("div", {
    "onMouseLeave": v.depLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, v.text("\n        "), (v.depRows || []).map((row, index50) => React.createElement(React.Fragment, {
    key: index50
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": v.depCols,
      "gap": "0.185185vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.018519vh 'IBM Plex Mono',monospace",
      "color": row.labC,
      "alignSelf": "center"
    }
  }, v.text(row.lab)), (row.cells || []).map((c, index51) => React.createElement(React.Fragment, {
    key: index51
  }, React.createElement("div", {
    "onMouseEnter": c.enter,
    "onClick": c.click,
    style: {
      "background": c.bg,
      "outline": c.ol,
      "borderRadius": "0.185185vh",
      "cursor": "pointer",
      "minHeight": "0.37037vh"
    }
  }, null))), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "paddingLeft": "0.416667vw",
      "minWidth": "0"
    }
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "height": "60%",
      "maxHeight": "0.925926vh",
      "display": "flex"
    }
  }, React.createElement("div", {
    style: {
      "width": row.totW,
      "background": "oklch(0.75 0.09 190 / 0.7)",
      "borderRadius": "0.092593vh"
    }
  }, null)), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "width": "2.291667vw",
      "textAlign": "right",
      "whiteSpace": "nowrap"
    }
  }, v.text(row.totV)))))), v.text("\n        "), v.depTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": v.depTip.left,
      "top": v.depTip.top,
      "transform": v.depTip.tx,
      "zIndex": "40",
      "width": "13.020833vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.462963vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.45)"
    }
  }, React.createElement("div", {
    style: {
      "fontWeight": "600",
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "paddingBottom": "0.37037vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.14)"
    }
  }, v.text(v.depTip.title)), (v.depTip.rows || []).map((r, index52) => React.createElement(React.Fragment, {
    key: index52
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh"
    }
  }, React.createElement("span", {
    style: {
      "color": r.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(r.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text(r.v))))), React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text(v.depTip.foot)))) : null, v.text("\n      ")), v.text("\n      "))) : null;
}
